import React from 'react';
import './BecomeASellerLetsGetStartedSection.scss';
import { Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import getStartedImage from '../../../../assets/images/become_a_seller_page/new/get_started_image.jpg';
import { SessionManager } from '../../../../services/SessionManager/SessionManager';

const BecomeASellerLetsGetStartedSection = () => {
  const navigate = useNavigate();
  
  const steps = [
    { title: "Sign-up:", description: "Create your account" },
    { title: "Register As Freelancer:", description: "Register youself as a freelancer. It is the time to flex!" },
    { title: "Add your Gig:", description: "List your services you're expert at though Freelancer Dashboard" },
    { title: "And You're Done!", description: "Get listed and start getting orders. Happy Earning!" }
  ];

  const handleGetStarted = () => {
    const isLoggedIn = SessionManager.shared.isLoggedin();
    if (isLoggedIn) 
      navigate('/become-a-freelancer/register');
    else 
      navigate('/login');
  };

  return (
    <div className="become-freelancer-lets-get-started">
      <div className="get-started-container">
        <div className="get-started-card">
          {/* Header */}
          <div className="get-started-header">
            <Typography variant="h3" className="get-started-title">
              Ready to Experience the Difference?
            </Typography>
            <Typography variant="h6" className="get-started-subtitle">
              Join thousands of freelancers who've already discovered a better way to work, earn, and grow their careers.
            </Typography>
          </div>

          {/* Steps */}
          <div className="steps-section">
            <div className="steps-list">
              {steps.map((step, index) => (
                <div key={index} className="step-item">
                  <div className="step-number">
                    {index + 1}.
                  </div>
                  <Typography variant="body1" className="step-text">
                    <strong>{step.title}</strong> {step.description}
                  </Typography>
                </div>
              ))}
            </div>
            <Typography variant="body2" className="happy-freelancing">
              Happy freelancing!
            </Typography>
          </div>

          {/* CTA Button */}
          <div className="cta-section-lets-get-started">
            <Button 
              className="get-started-button"
              onClick={handleGetStarted}
              variant="contained"
              size="large"
            >
              Let's Get Started
            </Button>
          </div>
        </div>
        <img src={getStartedImage} alt="Get Started" className="get-started-image">
        </img>
      </div>
    </div>
  );
};

export default BecomeASellerLetsGetStartedSection;
